import { useContext } from 'react';
import { HistoryContext } from '../../CompatRouter';
import { CustomBrowserHistory } from '../../containers/core/models/routing';

export function useHistory(): CustomBrowserHistory {
  return useContext(HistoryContext);
}
